export default __webpack_public_path__ + "static/iconography-styles-fb214a58f25ecacd29b49b3f215d9c02981cbe64d854ff3f7d6fb37827b98c6d.png";